export const getters = {
    getProvider: state => state.provider,
    IsLogin: state => state.isEnable,
    IsWalletHolder: state => state.holder,
    getIdToken: state => state.idToken,
    getConnectedWallet: state => state.connectedWallet,
    getSignature: state => state.signature,
    getProcessing: state => state.processing,
    getAddress: state => state.address ? state.address : ""
};
